import React from 'react';
import { useFormikContext, getIn } from "formik";
import ErrorMessage from './ErrorMessage';
import { FormGroup, Input } from 'reactstrap';
import { useEdit } from '../../Services/EditContext';
import { FormLabel } from './FormLabel';
import CompareFormValue from './CompareFormValue';
import { InputType } from 'reactstrap/es/Input';

interface Props {
    compare?: unknown; displayValue?: unknown; readOnly?: boolean; id: string;
    label?: string; type?: InputType; noEdit?: boolean;
    prefix?: string; suffix?: string;
    onChange?: (id: string, value: unknown) => unknown;
    value?: unknown; placeholder?: string;
    min?: number;
    max?: number;
}

const FormTextArea = ({ compare, displayValue, readOnly, id, label, type, noEdit, prefix, suffix, onChange,  value, placeholder, ...rest }: Props) => {
    const { handleChange, values, errors, touched } = useFormikContext(); 

    const changed = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value
        .replace(/[\n\r]/g, " ")  // Replace enters with spaces
        .replace(/[^\w\s.,#!(){\/[\]|}$%&+\-;:""@_=?]/gi, ""); // Remove unwanted chars (note: removed \n\r)

        onChange ? onChange(id, e.target.value) : handleChange(e);
    };
   
    const [edit] = useEdit();


    return <FormGroup>
        {label ? <FormLabel htmlFor={id} style={{ display: 'block' }}>{label}</FormLabel> : null}
        <ErrorMessage name={id} />
        {edit && !noEdit ? <Input {...rest} placeholder={placeholder} readOnly={readOnly} id={id} invalid={getIn(errors, id) && getIn(touched, id)} name={id} type={type} onChange={changed} value={getIn(values, id)} /> :
            <CompareFormValue type={type} compare={compare} id={id}></CompareFormValue>}

    </FormGroup>

}

export default FormTextArea
